<template>
  <div>
    <!-- <p>
      index de clients
    </p>

    <p>
      fazer CRUD por aqui
    </p>

    <p>
      Editar chama ClientProfile para add contratos e processos
    </p>

    <p>
      Chamar o ClientProfile aqui
      -- inserir ClientTransactions em profile
    </p>

    {{$route.path}} -->


    <v-card style="border-radius:12px">
      <v-toolbar flat color="white">
        <v-toolbar-title>Clientes</v-toolbar-title>
        <v-divider class="mx-4" inset vertical ></v-divider>
        <div class="flex-grow-1"></div>
        <v-btn rounded color="primary" dark class="mb-2" to="/clients/new">Novo</v-btn>

      </v-toolbar>

      <!-- Filtros -->
      <v-card-text class="pb-0">
        <v-expansion-panels v-model="filtersPanel" flat>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-icon class="mr-2">mdi-filter</v-icon>
                    Filtros Avançados
                  </v-col>
                  <v-col cols="8" class="text--secondary">
                    <v-fade-transition leave-absolute>
                      <span v-if="open" key="0">Configure os filtros de busca</span>
                      <span v-else key="1">{{ activeFiltersText }}</span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
                         <v-expansion-panel-content>
               <v-row class="mt-2">
                 <!-- Busca por nome/email -->
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filters.search"
                    label="Buscar por nome ou email"
                    prepend-icon="mdi-magnify"
                    clearable
                    filled
                    hide-details
                    @keyup.enter="applyFilters"
                  ></v-text-field>
                </v-col>

                <!-- Tipo de cliente -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="filters.client_type"
                    :items="clientTypes"
                    label="Tipo de Cliente"
                    prepend-icon="mdi-account-group"
                    clearable
                    filled
                    hide-details
                  ></v-select>
                </v-col>

                <!-- Ordenação -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="filters.sort_by"
                    :items="sortOptions"
                    label="Ordenar por"
                    prepend-icon="mdi-sort"
                    filled
                    hide-details
                    class="filter-select"
                  ></v-select>
                </v-col>

                <!-- Direção da ordenação -->
                <v-col cols="12" md="6">
                  <v-select
                    v-model="filters.sort_direction"
                    :items="sortDirections"
                    label="Direção"
                    prepend-icon="mdi-sort-variant"
                    filled
                    hide-details
                    class="filter-select"
                  ></v-select>
                </v-col>

                                 <!-- Botões de ação -->
                 <v-col cols="12" class="pt-4">
                   <v-row>
                     <v-col>
                       <v-btn color="primary" @click="applyFilters" :loading="loading">
                         <v-icon left>mdi-filter</v-icon>
                         Aplicar Filtros
                       </v-btn>
                       <v-btn text @click="clearFilters" class="ml-2">
                         <v-icon left>mdi-filter-remove</v-icon>
                         Limpar
                       </v-btn>
                     </v-col>
                   </v-row>
                 </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-text class="ma-0 py-1">
        <v-row justify="center" v-if="!allClients">
          <v-col cols="12" align="center">
            <card-loading ></card-loading>
          </v-col>
        </v-row>
        <!-- <index-table :headers="headers" :items="allClients" @editing="editing($event)" @deleting="deleting($event)"></index-table> -->
        <index-table :headers="headers" :items="allClients" :deletion_enabled="false" :disable_local_search="true" @editing="editing($event)"></index-table>

        <!-- Informações de paginação -->
        <v-row class="mt-2" v-if="allClients && allClients.length > 0">
          <v-col cols="12" md="6">
            <div class="text-sm-body-2 text-xs-caption">
              Mostrando {{ startItem }} - {{ endItem }} de {{ pagination.total_count }} clientes
            </div>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
                         <v-select
               v-model="filters.per_page"
               :items="perPageOptions"
               label="Itens por página"
               @change="applyFilters"
               style="max-width: 150px; display: inline-block;"
               outlined
               hide-details
             ></v-select>
          </v-col>
        </v-row>

        <!-- Paginação -->
        <v-row justify="center" v-if="pagination.total_pages > 1">
          <v-col cols="12">
            <v-pagination
              v-model="filters.page"
              :length="pagination.total_pages"
              :total-visible="7"
              @input="changePage"
              circle
            ></v-pagination>
          </v-col>
        </v-row>

        <!-- Estado vazio -->
        <v-row v-if="allClients && allClients.length === 0" justify="center">
          <v-col cols="12" class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-account-search</v-icon>
            <div class="text-h6 grey--text text--lighten-1 mt-2">
              Nenhum cliente encontrado
            </div>
            <div class="grey--text mt-1">
              Tente ajustar os filtros ou criar um novo cliente
            </div>
            <v-btn color="primary" class="mt-4" @click="clearFilters">
              Ver todos os clientes
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    IndexTable: () => import('@/components/shared/IndexTable'),
  },
  data() {
    return {
      loading: false,
      loadingText: null,
      filtersPanel: 0, // null = fechado, 0 = aberto

      // Filtros
      filters: {
        page: 1,
        per_page: 20,
        search: '',
        client_type: '',
        sort_by: 'created_at',
        sort_direction: 'desc'
      },

      // Headers da tabela
      headers:[
        { text: 'Nome', width: '30%' ,align: 'left', sortable: false, value: 'name'},
        { text: 'E-mail', width: '30%' ,align: 'left', sortable: false, value: 'email'},
        { text: 'Documento', width: '30%' ,align: 'left', sortable: false, value: 'document_number'},
        { text: 'Ação', value: 'action', sortable: false },
      ],

      // Opções para filtros
      clientTypes: [
        { text: 'Pessoa Física', value: 'natural' },
        { text: 'Pessoa Jurídica', value: 'juridica' }
      ],

      sortOptions: [
        { text: 'Data de Criação', value: 'created_at' },
        { text: 'Nome', value: 'name' },
        { text: 'E-mail', value: 'email' },
        { text: 'Documento', value: 'document_number' },
        { text: 'Última Atualização', value: 'updated_at' }
      ],

      sortDirections: [
        { text: 'Mais Recentes', value: 'desc' },
        { text: 'Mais Antigos', value: 'asc' }
      ],

      perPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ]
    }
  },
  methods: {
    editing(id) {
      this.loading = true
      this.loadingText = "Carregando"
      setTimeout(() => {
        this.$router.push('/clients/show/'+id)
      }, 1200);
      // Api.User.show(id)
      //   .then(response=>response.data)
      //   .then(user=>{
      //     this.oneUser = user.data.attributes
      //     this.loading = false
      //     this.loadingText = null
      //     this.dialogUser = true
      //   })
    },
    deleting(id) {
      this.loading = true
      this.loadingText = "Apagando"
      setTimeout(() => {
        this.updateToDelete(id)
      }, 1200);
    },
    applyFilters() {
      this.loading = true
      this.filters.page = 1 // Reset para primeira página
      this.clientIndex(this.filters)
    },
    clearFilters() {
      this.filters = {
        page: 1,
        per_page: 20,
        search: '',
        client_type: '',
        sort_by: 'created_at',
        sort_direction: 'desc'
      }
      this.applyFilters()
    },
    changePage(page) {
      this.filters.page = page
      this.loading = true
      this.clientIndex(this.filters)
    },
    ...mapActions({
      // function: 'Module/action',
      clientIndex: 'Client/index',
      updateToDelete: 'Client/updateToDelete',
    })
  },
  computed: {
    ...mapState({
      allClients: state => state.Client.allClients,
      pagination: state => state.Client.pagination,

      // data: state=> state.Module.state_var
    }),

    activeFiltersText() {
      const filters = []
      if (this.filters.search) filters.push(`Busca: "${this.filters.search}"`)
      if (this.filters.client_type) {
        const type = this.clientTypes.find(t => t.value === this.filters.client_type)
        filters.push(`Tipo: ${type && type.text}`)
      }
      return filters.length > 0 ? filters.join(', ') : 'Nenhum filtro aplicado'
    },

    startItem() {
      return ((this.pagination.current_page - 1) * this.pagination.per_page) + 1
    },

    endItem() {
      const end = this.pagination.current_page * this.pagination.per_page
      return Math.min(end, this.pagination.total_count)
    }
  },
  created () {
    this.clientIndex(this.filters)
  },
  watch: {
    allClients(newVal) {
      if (newVal) {
        this.loading = false
        this.loadingText = null
      }
    }
  },
}
</script>

<style scoped>
/* Estilo uniforme para todos os campos de filtro */
.v-text-field--filled >>> .v-input__control .v-input__slot,
.v-select.v-text-field--filled >>> .v-input__control .v-input__slot,
.filter-select >>> .v-input__control .v-input__slot {
  min-height: 48px !important;
  align-items: center !important;
}

/* Label consistente para todos os campos filled */
.v-text-field--filled >>> .v-input__control .v-input__slot .v-label,
.v-select.v-text-field--filled >>> .v-input__control .v-input__slot .v-label,
.filter-select >>> .v-input__control .v-input__slot .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}

/* Input text alinhado no centro */
.v-text-field--filled >>> .v-input__control .v-input__slot input {
  align-self: center !important;
}

/* Select text alinhado no centro */
.v-select.v-text-field--filled >>> .v-input__control .v-input__slot .v-select__selection {
  align-self: center !important;
}
</style>